import React, { useEffect, useState } from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import { useParksViewContext } from "provider/ParkViewProvider";
import parse from 'html-react-parser';
import ParkAboutSectionSkeleton from "components/common/Skeleton/park/ParkAboutSectionSkeleton";
import GetQuoteForm from "components/common/GetQuoteForm";
import { useAuth } from "provider/AuthContext";

function OverviewTab() {
  const { parkDetail, parkAccomOptions, parkViewLoading } = useParksViewContext();
  const { isLoggedIn } = useAuth();
  const [tabId, setTabId] = useState('about-park');
  const apiKey = process.env.REACT_APP_GOOGLE_CLOUDE_API_KEY;
  const latitude = parkDetail?.latitude;
  const longitude = parkDetail?.longitude;

  const mapSrc = latitude && longitude
    ? `https://www.google.com/maps/embed/v1/view?key=${apiKey}&center=${latitude},${longitude}&zoom=15&maptype=roadmap`
    : "";

  useEffect(() => {
    const handleScroll = () => {
      const sectionIds = ['about-park', 'safari-zones', 'flora', 'reach', 'map'];
      const scrollPosition = window.scrollY + 160; // offset for sticky headers

      for (let id of sectionIds) {
        const section = document.getElementById(id);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            setTabId(id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    setTabId(id);
    const headerOffset = 150;
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <Row className="justify-content-evenly">
      <Col xl={2} className="mb-xl-0 mb-4">
        <div
          className="miniTabs bg-white p-2"
          style={{ borderRadius: "15px" }}
        >
          <div className="tabsItems">
            <div className="items d-flex flex-column">
              <a href="#" className={`tab_link mb-3 ms-3  ${tabId === 'about-park' ? 'active' : ''}`}>
                About Park
              </a>
              <a href="#" className={`tab_link mb-3 ms-3 ${tabId === 'safari-zones' ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("safari-zones");
                }}>
                Safari Zones
              </a>
              <a href="#" className={`tab_link mb-3 ms-3 ${tabId === 'flora' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); scrollToSection("flora") }}>
                Flora & Fauna
              </a>
              <a href="#" className={`tab_link mb-3 ms-3 ${tabId === 'reach' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); scrollToSection("reach") }}>
                How to Reach
              </a>
              <a href="#" className={`tab_link mb-3 ms-3 ${tabId === 'map' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); scrollToSection("map") }}>
                Map
              </a>
              {/* <Link
                to={parkDetail?.official_website}
                target="_blank"
                className="tab_link mb-3 ms-3 text-primary"
              >
                Official Website{" "}
                <span>
                  <SlArrowRight />
                </span>
              </Link> */}
            </div>
          </div>
        </div>
      </Col>
      <Col xl={7} className="pb-4 park-pack-bg" >
        <Accordion defaultActiveKey="0" className="remove_border" >
          <Accordion.Item eventKey="0" className="tab-content" >
            <div className="p-3" style={{ borderRadius: "15px" }}>
              {parkViewLoading ? <ParkAboutSectionSkeleton />
                : <div
                  id="about-park"
                  className="about_title pb-4"
                  style={{ borderBottom: "1px solid #0000004D" }}
                >
                  <h4>About {parkDetail?.about_title}</h4>
                  {parkDetail?.about_description && parse(parkDetail?.about_description)}

                </div>
              }
            
              <Row className="pt-5" id="safari-zones">
                <h4 >Safari Zones of {parkDetail?.about_title}</h4>
                <Col lg={12} xl={12} className="mb-3 mb-xl-0">
                  <Row className="gx-2">
                    <Col sm={2} className="mb-sm-0 mb-3 ">
                      <div className="coreZone h-100">
                        <h3>CORE ZONE</h3>
                      </div>
                    </Col>
                    <Col sm={10} className="mb-sm-0 mb-3">
                      <div className="tabledesigncore">
                        <table className="table w-100 mb-0">
                          <thead>
                            <tr>
                              <th>Zone Name</th>
                              <th>Entry Gate</th>
                            </tr>
                          </thead>
                          <tbody>
                            {parkDetail?.core_zones?.map((core, index) => (
                              <tr className={core?.is_open_in_monsoon ?  'zone_active' : 'zone_deactive'} key={index}>
                                <td>{core.zone_name}</td>
                                <td>{core?.entry_gate_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12} xl={12} className="mt-3">
                  <Row className="gx-2 ">
                    <Col sm={2} className="mb-sm-0 mb-3">
                      <div className="bufferzone h-100">
                        <h3>BUFFER ZONE</h3>
                      </div>
                    </Col>
                    <Col sm={10} className="mb-sm-0 mb-3">
                      <div className="tabledesignbuffer">
                        <table className="table w-100 mb-0">
                          <thead>
                            <tr>
                              <th>Zone Name</th>
                              <th>Entry Gate</th>
                            </tr>
                          </thead>
                          <tbody>
                            {parkDetail?.buffer_zones?.map(
                              (buffer, index) => (
                                <tr className={buffer?.is_open_in_monsoon ?  'bzone_active' : 'zone_deactive'} key={index}>
                                  <td>{buffer.zone_name}</td>
                                  <td>{buffer.entry_gate_name}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                className="pt-3 pb-5"
                style={{ borderBottom: "1px solid #0000004D" }}
              >
                <Col lg={12} xl={12} md={12}>
                  <div className="legends_wrap d-flex justify-content-md-end gap-md-4 gap-2 ">
                    <div className="legends_bx d-flex align-items-center gap-2">
                      <div className="legends closedbg"></div>
                      <p>Currently Closed</p>
                    </div>
                    <div className="legends_bx d-flex align-items-center gap-2">
                      <div className="legends Core-Open"></div>
                      <p>Core Zone Open</p>
                    </div>
                    <div className="legends_bx d-flex align-items-center gap-2">
                      <div className="legends BufferZoneOpen"></div>
                      <p>Buffer Zone Open</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row id="flora">
                <div className="flora_title pt-3">
                  {parkDetail?.florafauna && parse(parkDetail?.florafauna)}
                </div>
              </Row>
              <Row id="reach">
                <div className="flora_title pt-3">
                  <h4>About {parkDetail?.module_title}</h4>
                  {parkDetail?.module_description && parse(parkDetail?.module_description)}
                </div>
              </Row>


              <Row id="map">
                <div className="fauna pt-4">
                  <h4>Map</h4>
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0" className="tab-content">
                      <Accordion.Body className="height_set p-0">
                        <iframe
                          src={mapSrc}
                          width="100%"
                          height="480"
                          style={{
                            border: "0",
                          }}
                          allowfullscreen=""
                          loading="lazy"
                          referrerpolicy="no-referrer-when-downgrade"
                          className="map-main"
                          title="map"
                        ></iframe>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Row>
            </div>
          </Accordion.Item>
        </Accordion>
      </Col>
      <Col xl={3} className="">
        {isLoggedIn ?
          <>
            <GetQuoteForm title={`Get free ${parkDetail?.title} quotes from multiple operators!`} quotationFormNote={parkDetail?.quotation_form_note || ''} reqUrl={`park/${parkDetail?.slug}/quotesrequest`} quoteRequestFrom="parkView" parkDropDown={[]} accomDropDown={parkAccomOptions || []}/>
          </>
          :
          <picture className="position-relative">
            <source
              srcSet={"/img/quote_req_big.png"}
              media="(max-width:576px)"
              type="image/png"
              style={{ borderRadius: "10px" }}
            />
            <img
              src="/img/quote_req_big.png"
              className="d-block w-100 banner_search"
              alt="banner"
              type="image/png"
              loading="lazy"
              style={{ borderRadius: "10px" }}
            />
          </picture>
        }

      </Col>
    </Row>
  );
}

export default OverviewTab;
